export const environment = {
  production: false,
  apiUrl: 'https://api-dev.mascredimas.us',

  // Entra ID (Azure AD) Configuration - Uses "Angular DEV Puntomas" app (single-tenant)
  msalConfig: {
    auth: {
      clientId: 'c8dcd59d-9d85-4925-afce-5383fda1e48c',
      authority: 'https://login.microsoftonline.com/6cdfbc33-3f56-4134-822c-e24936dea384',
      redirectUri: 'https://purple-dune-0750a060f.3.azurestaticapps.net/auth/microsoft/callback',
      postLogoutRedirectUri: 'https://purple-dune-0750a060f.3.azurestaticapps.net/auth/login'
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false
    }
  },
  msalGuardConfig: {
    interactionType: 'redirect',
    authRequest: {
      scopes: ['user.read', 'openid', 'profile', 'email']
    }
  },
  visualGoogleDrive: 'https://docs.google.com/viewer?url=',
};
